module.exports = __webpack_public_path__ + "lato-light-webfont.a2ed0581325d184de093.woff";


//////////////////
// WEBPACK FOOTER
// C:/WS/Fusion/FusionDashboard/resources/fonts/lato-light-webfont.woff
// module id = ../../../../../resources/fonts/lato-light-webfont.woff
// module chunks = styles